import * as React from "react";
import {useState} from "react";

import "./justListedJustSoldField.scss";

import {CustomizationTile}  from "./customizationTile";
import {Input}              from "./input";


export const JustListedJustSoldField = ({justListedJustSoldFieldData, domRef, setUnsavedChanges}) => {

    const idDisplayStyle = justListedJustSoldFieldData.idDisplayStyle;
    const defaultVal = idDisplayStyle == 3 ?
        JSON.parse(justListedJustSoldFieldData.defaultValue) : justListedJustSoldFieldData.defaultValue;
    const required = justListedJustSoldFieldData.required;
    const hidden = !justListedJustSoldFieldData.visible || idDisplayStyle == 6;

    const [labelValue, setLabelValue] = useState(justListedJustSoldFieldData.displayLabel);
    const [fieldValue, setFieldValue] = useState(idDisplayStyle == 3 ?
        justListedJustSoldFieldData.data == justListedJustSoldFieldData.defaultValue  ? "" : justListedJustSoldFieldData.data:
        justListedJustSoldFieldData.data);
    const [ckValue, setCkValue] = useState(0);

    function setLabelHandler () {
        setLabelValue(event.target.value);
    }

    function setFieldHandler () {
        setFieldValue(event.target.value);
    }

    function setCkValueHandler () {
        setCkValue(currVal => currVal == 0 ? 1 : 0);
    }


    return (
        <div className="just-listed-just-sold-field-78g" hidden={hidden}>
            <CustomizationTile
                domRef={domRef}
                header="Order Type"
                xdQaName="Order Type"
            >
                <>
                    {required ? <span className="field-required">*</span> : ""}
                    {idDisplayStyle == 1 &&
                        <Input
                            inputField={justListedJustSoldFieldData}
                            dataFieldName={labelValue}
                            fieldValue={fieldValue}
                            changeHandler={setFieldHandler}
                        />
                    }
                    {idDisplayStyle == 2 &&
                        <div className="edit-label-and-input-instance">
                            <div className="check">
                                <div>
                                    <Input
                                        inputField={justListedJustSoldFieldData}
                                        inputType="checkbox"
                                        fieldValue={ckValue}
                                        changeHandler={setCkValueHandler}
                                        xdQaType="checkbox"
                                        extraInfo={{"data-multipartfield": "deleteField"}}
                                    />
                                </div>
                            </div>
                            <div className="label">
                                <div xd-qa-type="label" xd-qa-name={justListedJustSoldFieldData.displayLabel}>
                                    <Input
                                        inputField={justListedJustSoldFieldData}
                                        fieldValue={labelValue}
                                        className="custom-label-504"
                                        changeHandler={setLabelHandler}
                                        extraInfo={{"data-multipartfield": "label"}}
                                        xdQaType="label"
                                    />
                                </div>
                            </div>
                            <div className="input">
                                <Input
                                    inputField={justListedJustSoldFieldData}
                                    dataFieldName={labelValue}
                                    fieldValue={fieldValue}
                                    changeHandler={setFieldHandler}
                                    extraInfo={{"data-multipartfield": "data"}}
                                />
                            </div>
                        </div>
                    }
                    {idDisplayStyle == 3 &&
                        <select defaultValue={fieldValue} name={justListedJustSoldFieldData.fieldKey} onChange={setUnsavedChanges} data-fieldname={justListedJustSoldFieldData.displayLabel} xd-qa-type="dropdown" xd-qa-name={justListedJustSoldFieldData.fieldKey}>
                            {!fieldValue &&
                                <option value="" disabled selected>
                                    - Select -
                                </option>
                            }
                            {
                                defaultVal?.map((value) =>
                                    <option key={value} value={value} xd-qa-type="dropdown_item" xd-qa-name={value} >
                                        {value}
                                    </option>
                                )
                            }
                        </select>
                    }
                    {idDisplayStyle == 6 &&
                        <Input
                            inputField={justListedJustSoldFieldData}
                            inputFieldName={justListedJustSoldFieldData.fieldKey + "hidden"}
                            inputType="hidden"
                            fieldValue={fieldValue}
                            xdQaType="hidden"
                        />
                    }
                    {idDisplayStyle == 7 &&
                        <Input
                            inputField={justListedJustSoldFieldData}
                            fieldValue={fieldValue}
                            changeHandler={() => null}
                            readOnly={true}
                        />
                    }
                </>
            </CustomizationTile>
        </div>
    )
};